import {computed, Injectable, signal} from '@angular/core';
import {NonNullableFormBuilder, Validators} from "@angular/forms";
import {FinanceFilterForm, FinanceFilterModel} from "../models/finance-filter-model";
import {DEFAULT_DATA_SOURCE_ID} from "../constants/finance-filter-constants";
import {BehaviorSubject} from "rxjs";
import moment from 'moment';
import {TramsDataSourceModel} from "../../payments/models/trams-data-source";

@Injectable({
  providedIn: 'root'
})
export class FinanceFilterModalService {
  public readonly toggleModal = signal(false);

  public readonly dataSources = signal<TramsDataSourceModel[]>([]);

  private readonly filtersValue = signal<FinanceFilterModel>({
    TravelTypeIds: [],
    SubmitToList: [],
    IssueDateFrom: new Date(),
    IssueDateTo: new Date(),
    DataSourceId: DEFAULT_DATA_SOURCE_ID,
    BranchIds: [],
  });

  public readonly selectedDataSource = computed(() => {
    const dataSources = this.dataSources();
    const selectedDataSource = dataSources.find(ds => ds.id === this.filtersValue().DataSourceId);
    return selectedDataSource?.sourceName ?? '';
  });

  private readonly filters$ = new BehaviorSubject<FinanceFilterModel>({
    TravelTypeIds: [],
    SubmitToList: [],
    IssueDateFrom: new Date(),
    IssueDateTo: new Date(),
    DataSourceId: DEFAULT_DATA_SOURCE_ID,
    BranchIds: [],
  });

  public get dates() {
    const today = moment();
    const dateFrom = moment().subtract(1, 'month');

    return {
      dateFrom: dateFrom.toDate(),
      dateTo: today.toDate()
    }
  }

  constructor(private readonly formBuilder: NonNullableFormBuilder) {
  }

  public getForm(travelTypes: number[], submitToList: string[], branches: number[]): FinanceFilterForm {
    const {dateFrom, dateTo} = this.dates;
    return this.formBuilder.group({
      TravelTypeIds: [travelTypes],
      SubmitToList: [submitToList],
      IssueDateFrom: [dateFrom, Validators.required],
      IssueDateTo: [dateTo, Validators.required],
      DataSourceId: [DEFAULT_DATA_SOURCE_ID, Validators.required],
      BranchIds: [branches],
    })
  }

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: FinanceFilterModel) {
    this.filters$.next(value);
    this.filtersValue.set(value);
  }
}
